module.exports = __webpack_public_path__ + "img/blueberry.4d200f17.jpg";